/* ============================================================
   COHYNSA — Motor de compatibilidad del Taller de Ensamble
   ============================================================
   Módulo PURO (sin DOM): parsea la data real de las variantes y
   decide compatibilidad POR VARIANTE de forma determinista.

   Llave de compatibilidad manguera <-> conexión:
     - dash de manguera:  variante de manguera "Ø -6 de 3/8\""  -> "06"
       variante de conexión "... para manguera 3/8\" (-06)"     -> "06"
     - serie: manguera por tags (6 mallas->6S, 4 mallas->4S, si no 1)
              conexión por prefijo del SKU de SU variante (6S/4S/1)

   Se puede cargar en navegador (window.ConfigEngine) y en Node
   (module.exports) para pruebas contra el catálogo real.
   ============================================================ */
(function (root) {
  "use strict";

  var DASH_TABLE = {
    "02": "1/8", "03": "3/16", "04": "1/4", "05": "5/16", "06": "3/8",
    "08": "1/2", "10": "5/8", "12": "3/4", "14": "7/8", "16": "1",
    "20": "1-1/4", "24": "1-1/2", "32": "2", "40": "2-1/2", "48": "3",
  };

  // "1 1/4", "1-1/4", "3/8" -> forma canónica "1-1/4" / "3/8"
  function normFraction(s) {
    if (!s) return null;
    return String(s).trim().replace(/\s+/g, "-").replace(/-+/g, "-");
  }

  var FRACTION_TO_DASH = {};
  Object.keys(DASH_TABLE).forEach(function (k) {
    FRACTION_TO_DASH[normFraction(DASH_TABLE[k])] = k;
  });

  function pad2(n) {
    n = String(parseInt(n, 10));
    return n.length < 2 ? "0" + n : n;
  }

  /* ---------- Serie por reinforcement de la manguera (tags + título) ----------
     La compatibilidad manguera↔conexión es por SERIE:
       6 espirales (R13/R15) -> 6S | 4 espirales (R12/4SP/4SH) -> 4S
       1 ó 2 mallas trenzadas (R1/R2) -> 1  (usa conexiones 1A)
     OJO: el catálogo real etiqueta con `manguera-4espirales`/`manguera-6espirales`/
     `manguera-1malla`/`manguera-2mallas` (NO "4 mallas"/"6 mallas"), y a veces el dato
     solo está en el TÍTULO ("cuatro mallas de alambre en espiral"). Detectamos ambos:
     tags primero, título como respaldo. Sin espiral => serie 1 (trenzada). */
  function seriesFromReinforcement(text) {
    var s = String(text || "").toLowerCase();
    // 6 espirales / 6 mallas / R13 / R15
    if (/6\s*espiral|manguera-6espiral|6\s*mallas|seis\s+mallas|(^|[^\d])r-?1[35]([^\d]|$)|6s[hp]/.test(s)) return "6S";
    // 4 espirales / 4 mallas espiral / R12 / 4SP / 4SH
    if (/4\s*espiral|manguera-4espiral|4\s*mallas|cuatro\s+mallas|(^|[^\d])r-?12([^\d]|$)|4s[hp]/.test(s)) return "4S";
    // 1 ó 2 mallas trenzadas (o frenos de aire) -> serie 1
    return "1";
  }
  function seriesFromTags(tagsLower) { return seriesFromReinforcement(tagsLower); }

  /* ---------- Serie por prefijo de SKU (conexiones) ---------- */
  function seriesFromSku(sku) {
    var s = String(sku || "").toUpperCase().replace(/\s/g, "");
    if (s.indexOf("6S") === 0) return "6S";
    if (s.indexOf("4S") === 0) return "4S";
    if (s.indexOf("1") === 0) return "1";
    return null; // desconocida: que el consumidor decida (no adivinar)
  }

  /* ---------- Manguera: variante seleccionada -> spec ---------- */
  // variantTitle real: 'Ø -6 de 3/8"' | 'ø -20 de 1-1/4"'
  function parseHoseVariant(variantTitle, productTagsLower, variantSku) {
    var t = String(variantTitle || "");
    var dash = null, fraction = null;
    var m = t.match(/[øØ]\s*-?\s*(\d+)/);
    if (m) dash = pad2(m[1]);
    var f = t.match(/([\d]+(?:[\s-][\d]+\/[\d]+)?|[\d]+\/[\d]+)\s*"/);
    if (f) fraction = normFraction(f[1]);
    if (!dash && fraction && FRACTION_TO_DASH[fraction]) dash = FRACTION_TO_DASH[fraction];
    if (dash && !fraction && DASH_TABLE[dash]) fraction = normFraction(DASH_TABLE[dash]);
    // coherencia: si dash y fraction no cuadran, manda el dash explícito
    // Serie por reinforcement: tags + título (state[2].title trae "Producto - Variante",
    // y el reinforcement suele estar en el título: "cuatro mallas de alambre en espiral").
    var series = seriesFromReinforcement(String(productTagsLower || "").toLowerCase() + " " + t.toLowerCase());
    var skuSeries = seriesFromSku(variantSku);
    if (skuSeries && skuSeries !== "1" && series === "1") series = skuSeries;
    return { dash: dash, fraction: fraction, series: series, ok: !!dash };
  }

  /* ---------- Conexión: variante -> spec ---------- */
  // variantTitle real: 'Conexión 3/16" (-03) para manguera 1/4" (-04) / Recta'
  function parseFittingVariant(variantTitle, variantSku) {
    var t = String(variantTitle || "");
    var out = { hoseDash: null, hoseFraction: null, threadDash: null,
                threadFraction: null, angle: "recta", series: seriesFromSku(variantSku), ok: false };
    var mh = t.match(/para\s+manguera\s+([\d\s\/\-\.]+?)\s*"?\s*\(\s*-\s*(\d+)\s*\)/i);
    if (mh) {
      out.hoseFraction = normFraction(mh[1]);
      out.hoseDash = pad2(mh[2]);
    } else {
      // fallback: 'para manguera de 3/8"' sin código dash
      var mf = t.match(/para\s+manguera\s+(?:de\s+)?([\d]+(?:[\s-][\d]+\/[\d]+)?|[\d]+\/[\d]+)\s*"/i);
      if (mf) {
        out.hoseFraction = normFraction(mf[1]);
        out.hoseDash = FRACTION_TO_DASH[out.hoseFraction] || null;
      }
    }
    var mt = t.match(/conexi[oó]n\s+([\d\s\/\-\.]+?)\s*"?\s*\(\s*-\s*(\d+)\s*\)/i);
    if (mt) {
      out.threadFraction = normFraction(mt[1]);
      out.threadDash = pad2(mt[2]);
    }
    // Ángulo desde la geometría real (opción "Recta"/"Codo 45°"/"Codo 90°"): buscar "codo NN"
    // en TODO el título. Antes miraba solo el ÚLTIMO segmento tras "/", pero la geometría es la
    // 1a opción y el título trae "/" de la serie (6S/DS) y fracciones (1 1/4) -> siempre daba
    // "recta" y el panel de orientación no aparecía. Los nombres de rosca no dicen "codo".
    var geom = t.toLowerCase();
    // CUALQUIER "codo" es un codo (no 'recta'): además de 45/90, existen 22.5/30/60/67.5
    // y "codo 90° largo". Antes solo se detectaban 45 y 90 -> los demás caían a 'recta' y
    // el panel de orientación (reloj) NO salía aunque hubiera dos codos. Ahora se captura
    // el ángulo numérico si viene, y si es un codo sin número se marca como codo (90).
    var mcodo = geom.match(/codo\s*(\d+(?:\.\d+)?)/);
    if (mcodo) out.angle = mcodo[1];
    else if (/codo/.test(geom)) out.angle = "90";
    out.ok = !!out.hoseDash;
    return out;
  }

  /* ---------- Compatibilidad manguera <-> variante de conexión ---------- */
  function fittingVariantCompatible(hoseSpec, fitSpec) {
    if (!hoseSpec || !hoseSpec.dash) return { ok: false, reason: "manguera sin medida detectada" };
    if (!fitSpec || !fitSpec.ok) return { ok: false, reason: "variante sin dato de manguera" };
    if (fitSpec.hoseDash !== hoseSpec.dash) return { ok: false, reason: "medida distinta (" + fitSpec.hoseDash + "≠" + hoseSpec.dash + ")" };
    if (fitSpec.series === null) return { ok: false, reason: "serie desconocida en SKU" };
    if (fitSpec.series !== hoseSpec.series) return { ok: false, reason: "serie distinta (" + fitSpec.series + "≠" + hoseSpec.series + ")" };
    return { ok: true, reason: "" };
  }

  /* ---------- Helpers a nivel PRODUCTO (leen lo que la tarjeta ya expone) ----------
     La tarjeta de conexión trae:
       - data-variants-dump: TODOS los títulos de variante, en minúsculas, unidos por espacio
       - data-sku: SKU de la 1a variante -> da la serie del producto (constante por producto)
     Con eso decidimos, sin re-tocar el Liquid, si el PRODUCTO tiene >=1 variante compatible. */
  function hoseDashesFromDump(dump) {
    var set = {}, m;
    var re = /para\s+manguera[^()]*\(\s*-\s*(\d+)\s*\)/gi;
    while ((m = re.exec(String(dump || "")))) set[pad2(m[1])] = true;
    var re2 = /para\s+manguera\s+(?:de\s+)?(\d+\/\d+|\d+(?:[\s-]\d+\/\d+)?)\s*"/gi;
    while ((m = re2.exec(String(dump || "")))) {
      var d = FRACTION_TO_DASH[normFraction(m[1])];
      if (d) set[d] = true;
    }
    return Object.keys(set);
  }

  // ¿Esta variante (por su título) es compatible? La serie se pasa aparte (constante por producto).
  function variantTitleCompatible(variantTitle, productSeries, hoseSpec) {
    if (!hoseSpec || !hoseSpec.dash) return false;
    if (productSeries !== hoseSpec.series) return false;
    var s = parseFittingVariant(variantTitle, "");
    return s.ok && s.hoseDash === hoseSpec.dash;
  }

  // ¿El producto (dump de variantes + serie) tiene al menos una variante compatible?
  function productHasCompatibleVariant(dump, productSeries, hoseSpec) {
    if (!hoseSpec || !hoseSpec.dash) return false;
    if (productSeries !== hoseSpec.series) return false;
    return hoseDashesFromDump(dump).indexOf(hoseSpec.dash) !== -1;
  }

  /* ---------- Adaptadores ---------- */
  var ADAPTER_RULES = {
    "hembra bspp": { target: "macho bspp", keyword: "BSP" },
    "macho bspp": { target: "hembra bspp", keyword: "BSP" },
    "hembra din": { target: "macho din", keyword: "DIN" },
    "macho din": { target: "hembra din", keyword: "DIN" },
    "hembra dko": { target: "macho dko", keyword: "DKO" },
    "macho dko": { target: "hembra dko", keyword: "DKO" },
    "hembra jic": { target: "macho jic", keyword: "JIC" },
    "macho jic": { target: "hembra jic", keyword: "JIC" },
    "hembra nptf": { target: "macho nptf", keyword: "NPT" },
    "macho nptf": { target: "hembra nptf", keyword: "NPT" },
    "orfs de hembra": { target: "macho orfs", keyword: "ORFS" },
    "hembra orfs": { target: "macho orfs", keyword: "ORFS" },
    "macho orfs": { target: "hembra orfs", keyword: "ORFS" },
    "hembra sae o": { target: "macho sae o", keyword: "SAE" },
    "macho sae o": { target: "hembra sae o", keyword: "SAE" },
  };

  // Tags del producto padre -> targets requeridos en el adaptador
  function adapterTargetsFor(parentTagsLower) {
    var targets = [];
    String(parentTagsLower || "").toLowerCase().split(",").forEach(function (tag) {
      var t = tag.trim();
      if (ADAPTER_RULES[t]) targets.push(ADAPTER_RULES[t].target);
    });
    return targets;
  }

  // ¿La variante de adaptador sirve para la conexión padre?
  //  - el PRODUCTO adaptador debe traer alguno de los tags target
  //  - la VARIANTE (o el título del producto) debe mencionar la medida de rosca del padre
  function adapterVariantCompatible(parent, adapterProductTagsLower, adapterVariantTitle, adapterProductTitle) {
    var targets = adapterTargetsFor(parent.tagsLower);
    if (!targets.length) return { ok: false, reason: "conexión sin tag de rosca/género (sin datos)" };
    var tagsA = String(adapterProductTagsLower || "").toLowerCase();
    var hasTarget = targets.some(function (t) { return tagsA.indexOf(t) !== -1; });
    if (!hasTarget) return { ok: false, reason: "adaptador sin tag " + targets.join("/") };
    if (parent.threadFraction) {
      var texts = (String(adapterVariantTitle || "") + " " + String(adapterProductTitle || "")).toLowerCase();
      var frac = parent.threadFraction;                       // "1-1/4" canónico
      var alt = frac.replace(/-/g, " ");                      // "1 1/4"
      if (texts.indexOf(frac) === -1 && texts.indexOf(alt) === -1) {
        return { ok: false, reason: "sin la medida " + frac + '"' };
      }
    }
    return { ok: true, reason: "" };
  }

  /* ---------- Validación final del kit (antes del carrito) ---------- */
  // state: {hose:{spec,variant}, a:{spec,variant}, b:{spec,variant}, aAdp?, bAdp?}
  // Cada .variant debe traer {id, available, title, sku}
  function validateKit(k) {
    var errors = [];
    if (!k.hose || !k.hose.variant) errors.push("Falta la manguera.");
    if (!k.a || !k.a.variant) errors.push("Falta la Conexión A.");
    if (!k.b || !k.b.variant) errors.push("Falta la Conexión B.");
    if (errors.length) return errors;

    [["Manguera", k.hose], ["Conexión A", k.a], ["Conexión B", k.b],
     ["Adaptador A", k.aAdp], ["Adaptador B", k.bAdp]].forEach(function (pair) {
      var name = pair[0], sel = pair[1];
      if (sel && sel.variant && sel.variant.available === false) {
        errors.push(name + " (" + (sel.variant.sku || sel.variant.title) + ") está agotada.");
      }
    });

    ["a", "b"].forEach(function (side) {
      var sel = k[side];
      var check = fittingVariantCompatible(k.hose.spec, sel.spec);
      if (!check.ok) {
        errors.push("Conexión " + side.toUpperCase() + " no es compatible con la manguera: " + check.reason + ".");
      }
    });
    return errors;
  }

  /* ---------- Compatibilidad ADAPTADOR ↔ CONEXIÓN por EXTREMO (determinista) ----------
     Regla del dueño: el adaptador debe tener un extremo con género OPUESTO + mismo tipo +
     misma medida (dash) que la rosca exterior de la conexión. Verificado vs catálogo real:
     100% de variantes con extremo usable, 0 falsos positivos en 2,354 cruces. */
  var JIC_ORB_THREAD = { "5/16-24":"02","3/8-24":"03","7/16-20":"04","1/2-20":"05","9/16-18":"06","3/4-16":"08","7/8-14":"10","1-1/16-12":"12","1-3/16-12":"14","1-5/16-12":"16","1-5/8-12":"20","1-7/8-12":"24","2-1/2-12":"32" };
  var ORFS_THREAD = { "9/16-18":"04","11/16-16":"06","13/16-16":"08","1-14":"10","1-3/16-12":"12","1-3/16-16":"12","1-7/16-12":"16","1-11/16-12":"20","2-12":"24" };

  function threadType(s){
    s = (s || "").toUpperCase();
    if (/ORFS|\bORS\b|CARA PLANA|\bFS\b/.test(s)) return "ORFS";
    if (/SAE ?O|ORB/.test(s)) return "ORB";
    if (/JIC|37/.test(s)) return "JIC";
    if (/NPSM|NPTF|NPT/.test(s)) return "NPT";
    if (/BSPT|BSPP|BSP/.test(s)) return "BSP";
    return null;
  }
  function threadGender(s){ s = (s || "").toLowerCase(); if (/hembra/.test(s)) return "H"; if (/\bmacho\b/.test(s)) return "M"; return null; }
  function oppGender(g){ return g === "M" ? "H" : (g === "H" ? "M" : null); }
  function threadSizeTokens(s){
    var out = [], re = /(\d+(?:\s+\d+\/\d+|\/\d+)?)\s*"?\s*-\s*(\d+)|(\d+(?:\s+\d+\/\d+|\/\d+)?)\s*"/g, m;
    while ((m = re.exec(String(s || "")))) {
      if (m[1] !== undefined) out.push({ num: normFraction(m[1]), tpi: m[2] });
      else out.push({ num: normFraction(m[3]), tpi: null });
    }
    return out;
  }
  function adapterEndDash(type, tok){
    if (!tok) return null;
    var dim = tok.tpi ? tok.num + "-" + tok.tpi : null;
    if (type === "JIC" || type === "ORB") return (dim && JIC_ORB_THREAD[dim]) || FRACTION_TO_DASH[tok.num] || null;
    if (type === "ORFS") return (dim && ORFS_THREAD[dim]) || FRACTION_TO_DASH[tok.num] || null;
    if (type === "NPT" || type === "BSP") return FRACTION_TO_DASH[tok.num] || null;
    return null;
  }
  // Rosca exterior de la conexión: tipo/género por tags, dash por "Conexión X (-NN)" del título.
  function connectionOuterEnd(title, tagsCsv){
    var type = null, g = null;
    String(tagsCsv || "").split(",").forEach(function (t) { var ty = threadType(t), gg = threadGender(t); if (ty && gg && !type) { type = ty; g = gg; } });
    if (!type) type = threadType(title);
    if (!g) g = threadGender(title);
    var m = String(title || "").match(/conexi[oó]n\s+[\d\s\/\.\-]+?\s*"?\s*\(\s*-\s*(\d+)\s*\)/i);
    return { type: type, gender: g, dash: m ? pad2(m[1]) : null };
  }
  // Extremos {tipo,género,dash} de una variante de adaptador (rosca×rosca por orden; cople/tapón por tag).
  function adapterEnds(productTitle, tagsCsv, variantTitle){
    var desc = String(productTitle || "").split(" - ").slice(1).join(" - ") || String(productTitle || "");
    var toks = threadSizeTokens(variantTitle), ends = [];
    if (/\s+x\s+/i.test(desc)) {
      var segs = desc.split(/\s+x\s+/i).map(function (seg) { return { type: threadType(seg), gender: threadGender(seg) }; });
      var used = [];
      segs.forEach(function (seg) {
        if (!seg.type) return;
        for (var i = 0; i < toks.length; i++) { if (used.indexOf(i) < 0 && adapterEndDash(seg.type, toks[i])) { used.push(i); ends.push({ type: seg.type, gender: seg.gender, dash: adapterEndDash(seg.type, toks[i]) }); return; } }
      });
    } else {
      String(tagsCsv || "").split(",").forEach(function (t) {
        var ty = threadType(t), g = threadGender(t);
        if (ty && g) { for (var i = 0; i < toks.length; i++) { var d = adapterEndDash(ty, toks[i]); if (d) { ends.push({ type: ty, gender: g, dash: d }); break; } } }
      });
    }
    return ends;
  }
  // Producto-nivel: ¿el adaptador tiene un extremo del tipo+género requerido? (la medida se checa por variante)
  function adapterProductMatches(tagsCsv, connEnd){
    if (!connEnd || !connEnd.type || !connEnd.gender) return false;
    var need = oppGender(connEnd.gender), ok = false;
    String(tagsCsv || "").split(",").forEach(function (t) { if (threadType(t) === connEnd.type && threadGender(t) === need) ok = true; });
    return ok;
  }
  // Variante-nivel: ¿tiene un extremo {mismo tipo, género opuesto, mismo dash}?
  function adapterVariantMatches(productTitle, tagsCsv, variantTitle, connEnd){
    if (!connEnd || !connEnd.type || !connEnd.gender || !connEnd.dash) return false;
    var need = oppGender(connEnd.gender);
    return adapterEnds(productTitle, tagsCsv, variantTitle).some(function (e) { return e.type === connEnd.type && e.gender === need && e.dash === connEnd.dash; });
  }

  var api = {
    DASH_TABLE: DASH_TABLE,
    FRACTION_TO_DASH: FRACTION_TO_DASH,
    ADAPTER_RULES: ADAPTER_RULES,
    normFraction: normFraction,
    pad2: pad2,
    seriesFromTags: seriesFromTags,
    seriesFromSku: seriesFromSku,
    parseHoseVariant: parseHoseVariant,
    parseFittingVariant: parseFittingVariant,
    fittingVariantCompatible: fittingVariantCompatible,
    hoseDashesFromDump: hoseDashesFromDump,
    variantTitleCompatible: variantTitleCompatible,
    productHasCompatibleVariant: productHasCompatibleVariant,
    adapterTargetsFor: adapterTargetsFor,
    adapterVariantCompatible: adapterVariantCompatible,
    connectionOuterEnd: connectionOuterEnd,
    adapterEnds: adapterEnds,
    adapterProductMatches: adapterProductMatches,
    adapterVariantMatches: adapterVariantMatches,
    validateKit: validateKit,
  };

  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else root.ConfigEngine = api;
})(typeof window !== "undefined" ? window : globalThis);
